import React, { useState, useEffect, useContext } from "react";
import { MDBCard, MDBCol, MDBContainer, MDBRow } from "mdb-react-ui-kit";
import { MDBBtn } from "mdb-react-ui-kit";
import { Link } from "react-router-dom";
import Skeleton from "@mui/material/Skeleton";
import axios from "axios";
// config
import configData from "../../../config/config.json";
// compponnents
import MetaTagsBusinessOwners from "../../../components/meta-tags-seo/MetaTagsBusinessOwners";
import RateIcon from "../../../components/Dashbord/rate-icon/RateIcon";
import Sidbarbusiness from "../../../components/business-dashboard/sidbar/Sidbarbusiness";
import HeaderMobile from "../../../components/business-dashboard/sidbar/HeaderMobile";
import DashboardCard from "../../../components/business-dashboard/dashboard-card/DashboardCard";
// img
import img1 from "../../../images/business dashboard/Component 18 – 1.png";
import img2 from "../../../images/business dashboard/Component 19 – 1.png";
import img3 from "../../../images/business dashboard/Component 19 – 2.png";
import img4 from "../../../images/business dashboard/Component 19 – 3.png";
import notif from "../../../images/business dashboard/notification.png";
import comm from "../../../images/business dashboard/comments.png";
import warningIcon from "../../../images/business dashboard/warning.png";

const BusinessDashboard = (props) => {
  const [render, setRender] = useState(false);

  const [bizStatus, setBizStatus] = useState("");

  const [viewCome, setviewCome] = useState(false);
  const [view, setview] = useState([
    {
      id: 1,
      // title: "روزانه",
      // view: 0,
      // image: img1,
      // color: "#ceffe8",
    },
    {
      id: 2,
      // title: "هفتگی",
      // view: 0,
      // image: img2,
      // color: "#e0cdff",
    },
    {
      id: 3,
      // title: "ماهانه",
      // view: 0,
      // image: img3,
      // color: "#fff1ca",
    },
    {
      id: 4,
      // title: "سالانه",
      // view: 0,
      // image: img4,
      // color: "#ffdbdb",
    },
  ]);
  const [rateCome, setRateCome] = useState(false);
  //give data from api
  const [rate, setRate] = useState({
    personCount: 0,
    all: 0,
    awli: 0,
    khob: 0,
    motevaset: 0,
    zaief: 0,
    bad: 0,
  });

  const [ownerDetail, setOwnerDetail] = useState({
    Firstname: "",
    Lastname: "",
  });
  const [hasDescription, setHasDescription] = useState(true);

  // this 2 satae for Meta Tags
  const [MTagsCome, setMTagsCome] = useState(false);
  const [MetaData, setMetaData] = useState({});

  //api header
  const headerMeta = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Page: "business-dashboard",
    Authorization: "Bearer " + getCookie("token"),
  };

  useEffect(() => {
    let OwnerIdCookie = getCookie("OwnerId");
    if (!OwnerIdCookie) {
      props.history.push({
        pathname: "/login",
      });
    } else if (render) {
      setviewCome(false);
      setRateCome(false);

      axios
        .get(configData.API_DOMAIN + "/api/v1/MetaTags/businessOwner", {
          headers: headerMeta,
        })
        .then((response) => {
          if (response.data.isSuccess) {
            setMTagsCome(true);
            setMetaData(response.data.data);
          }
        })
        .catch((error) => {
          // alert(error);
        });
      axios
        .get(configData.API_DOMAIN + "/api/v1/BusinessOwners", {
          headers: {
            ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
            LangId: 1,
            Authorization: "Bearer " + getCookie("token"),
          },
        })
        .then((response) => {
          if (response.data.isSuccess) {
            setOwnerDetail({
              Firstname: response.data.data.firstname,
              Lastname: response.data.data.lastname,
            });
          }
        })
        .catch((error) => {
          // alert(error);
        });

      axios
        .get(
          configData.API_DOMAIN + `/api/v1/Businesses/${getCookie("BizUuid")}`,
          {
            headers: {
              ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
              LangId: 1,
              Authorization: "Bearer " + getCookie("token"),
            },
          }
        )
        .then((response) => {
          if (response.data.isSuccess) {
            setBizStatus(response.data.data.approveStatus);
          }
        })
        .catch((error) => {
          // alert(error);
        });

      // 3 Visits بازدید
      axios
        .post(
          configData.API_DOMAIN + `/api/v1/Businesses/visits`,
          {
            bid: getCookie("BizId"),
          },
          {
            headers: {
              ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
              LangId: 1,
              Authorization: "Bearer " + getCookie("token"),
            },
          }
        )
        .then((response) => {
          if (response.data.isSuccess) {
            setviewCome(true);
            let data = response.data.data;
            setview([
              {
                id: 1,
                title: "روزانه",
                view: data.day.count,
                image: img1,
                color: "#ceffe8",
              },
              {
                id: 2,
                title: "هفتگی",
                view: data.week.count,
                image: img2,
                color: "#e0cdff",
              },
              {
                id: 3,
                title: "ماهانه",
                view: data.month.count,
                image: img3,
                color: "#fff1ca",
              },
              {
                id: 4,
                title: "سالانه",
                view: data.year.count,
                image: img4,
                color: "#ffdbdb",
              },
            ]);
          } else {
          }
        })
        .catch((error) => {
          // alert(error);
        });
      // 4 Rate
      axios
        .post(
          configData.API_DOMAIN + `/api/v1/Businesses/rates`,
          {
            bid: getCookie("BizId"),
          },
          {
            headers: {
              ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
              LangId: 1,
              Authorization: "Bearer " + getCookie("token"),
            },
          }
        )
        .then((response) => {
          if (response.data.isSuccess) {
            setRateCome(true);
            let data = response.data.data;
            setRate({
              personCount: data.personCount,
              all: data.score,
              awli: data.great,
              khob: data.excellent,
              motevaset: data.average,
              zaief: data.bad,
              bad: data.awful,
            });
          } else {
          }
        })
        .catch((error) => {
          // alert(error);
        });
    }
  }, [render]);

  //   getCookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  const lanHandler = (event) => {
    // if (getCookie("_gapp_Locale") == "") {
    window.location.href = `https://en-biz.gishniz.com${window.location.pathname}`;
    // window.location.href = `https://en-biz.gishniz.app${window.location.pathname}`;
    // }
  };

  let windowWidth = "00";
  if (typeof window !== "undefined") {
    // Code that relies on the window object
    windowWidth = window.innerWidth;
  } else {
    windowWidth = "00";
  }
  return (
    <>
      {MTagsCome ? <MetaTagsBusinessOwners data={MetaData} /> : ""}

      {windowWidth < 768 ? (
        <HeaderMobile
          setRender={setRender}
          setHasDescription={setHasDescription}
        />
      ) : (
        ""
      )}
      <div className="margin-0 d-flex bg_business_grey">
        <div className="  d-none d-md-block">
          {windowWidth > 767 ? (
            <Sidbarbusiness
              setRender={setRender}
              setHasDescription={setHasDescription}
            />
          ) : (
            ""
          )}
        </div>
        <MDBContainer className="bg_business_grey">
          <MDBRow>
            <MDBCol size="12">
              <div className="container-dashboard-bus">
                <div className="d-block">
                  <div className="d-flex align-items-baseline justify-content-between">
                    <p className="text_img_bus mx-0 mb-0">
                      سلام {ownerDetail.Firstname}
                    </p>
                    <MDBBtn className="chamge-lan-btn" onClick={lanHandler}>
                      En
                    </MDBBtn>
                  </div>
                  <p className="text_img_bus2 mx-0 ">
                    تازه‌ترین وضعیت کسب‌وکارتان را اینجا ببینید.
                  </p>
                  <p className="text_img_bus2 mb-0">
                    وضعیت کسب‌وکار:{" "}
                    <span className="color_span_info"> {bizStatus}</span>
                  </p>
                </div>
                {!hasDescription && (
                  <div className="dashboard-desc-alert">
                    <img src={warningIcon} alt="warning" />
                    لطفا کادر{" "}
                    <span
                      onClick={() => {
                        props.history.push({
                          pathname: "/business-information",
                          state: "description", // to open description collapse
                        });
                      }}
                    >
                      «توضیحات»
                    </span>{" "}
                    را در بخش اطلاعات کسب‌وکار کامل کنید.
                  </div>
                )}
                <p className="dashboard-bus-tit">بازدیدها</p>
                <div className="dashcards-res-dash-bus">
                  <MDBRow className="justify-content-xl-between justify-content-evenly ">
                    {view.map((item) => (
                      <div key={item.id} className="col-6 col-xl-3 centerr">
                        <DashboardCard
                          title={item.title}
                          bg={item.color}
                          view={item.view}
                          img={item.image}
                          viewCome={viewCome}
                        />
                      </div>
                    ))}
                  </MDBRow>
                </div>

                <MDBRow className="mb-3">
                  <MDBCol xl="4" lg="5" className="padding-col4-dash-bus">
                    {rateCome ? (
                      <div className="dash-bus-score">
                        <div className="d-flex justify-content-between align-items-baseline mb-1 mb-md-0">
                          <p className="dash-bus-score-p1">امتیاز</p>{" "}
                          <div className="d-flex align-items-baseline">
                            <div className="d-flex align-items-center">
                              <span className="f-db-27px ml--5 fw-bold">
                                {rate.all}
                              </span>
                              <span className="f-db-15px fw-bold">از 5</span>
                            </div>
                            <div className="mb-3 pb-md-1 me-2">
                              <span className="float-end gish-res-dash-bus">
                                <RateIcon
                                  cardrate={parseFloat(rate.all)}
                                  isRec={0}
                                  isAdd={0}
                                  isComment1={1}
                                  dir="ltr "
                                />
                              </span>
                              <br />
                              <span className=" text1-comment">
                                از مجموع {rate.personCount} نفر
                              </span>
                            </div>
                          </div>
                        </div>

                        <div>
                          <p className="mb--5">
                            <small className="float-end comment-prog-text">
                              عالی
                            </small>
                            <small className="float-start comment-prog-numb">
                              {rate.awli}
                            </small>
                          </p>
                          <progress
                            className="progress-color"
                            value={rate.awli}
                            max={rate.all}
                          ></progress>
                        </div>
                        <div>
                          <p className="mb--5">
                            <small className="float-end comment-prog-text">
                              خوب
                            </small>
                            <small className="float-start comment-prog-numb">
                              {rate.khob}
                            </small>
                          </p>
                          <progress
                            className="progress-color"
                            value={rate.khob}
                            max={rate.all}
                          ></progress>
                        </div>
                        <div>
                          <p className="mb--5">
                            <small className="float-end comment-prog-text">
                              متوسط
                            </small>
                            <small className="float-start comment-prog-numb">
                              {rate.motevaset}
                            </small>
                          </p>
                          <progress
                            className="progress-color"
                            value={rate.motevaset}
                            max={rate.all}
                          ></progress>
                        </div>
                        <div>
                          <p className="mb--5">
                            <small className="float-end comment-prog-text">
                              ضعیف
                            </small>
                            <small className="float-start comment-prog-numb">
                              {rate.zaief}
                            </small>
                          </p>
                          <progress
                            className="progress-color"
                            value={rate.zaief}
                            max={rate.all}
                          ></progress>
                        </div>
                        <div>
                          <p className="mb--5">
                            <small className="float-end comment-prog-text">
                              بد
                            </small>
                            <small className="float-start comment-prog-numb">
                              {rate.bad}
                            </small>
                          </p>
                          <progress
                            className="progress-color"
                            value={rate.bad}
                            max={rate.all}
                          ></progress>
                        </div>
                      </div>
                    ) : (
                      <Skeleton
                        className="dash-bus-score"
                        variant="rectangular"
                        height={300}
                        animation="wave"
                      />
                    )}
                  </MDBCol>
                  <MDBCol xl="8" lg="7" className="padding-col8-dash-bus">
                    <Link to={"/business-reviews"}>
                      <MDBCard className="dash-bus-comment">
                        <div className="dash-bus-comment-tit">
                          <span>دیدگاه‌ها</span>
                          <img
                            src={notif}
                            alt=".."
                            className="dash-bus-comment-tit-img"
                          />
                        </div>
                        <div className="dash-bus-comment-body">
                          <img
                            src={comm}
                            alt=""
                            className="dash-bus-comment-img d-block d-md-none"
                          />
                          {/* <span className="d-block d-md-none">
                            <span>از آخرین ورود شما تا به حال </span>
                            <br />
                            <span>دیدگاه جدیدی ثبت نشده است</span>
                          </span> */}
                          <span className="d-block mt33important">
                            از آخرین ورود شما تا به حال دیدگاه جدیدی ثبت نشده
                            است
                          </span>
                        </div>
                      </MDBCard>
                    </Link>
                    {/* <Link to={"/business-message"}> */}
                    <MDBCard className="dash-bus-comment m-md-0 mb-5">
                      <div className="dash-bus-comment-tit">
                        <span>پیام‌ها</span>
                        <img
                          src={notif}
                          alt=".."
                          className="dash-bus-comment-tit-img "
                        />
                        {/* <span className="small_circel_red"></span>
                          <span className="count_payam_red">34</span> */}
                      </div>
                      <div className="dash-bus-message-body">
                        {/* <div className="d-flex">
                            <div>
                              <p className="dash-bus-message-tit">مدیر سیستم</p>
                              <p className="dash-bus-message-matn d-none d-md-block">
                                درخواست شما برای ارتقا حساب کاربری دریافت شد.
                              </p>
                            </div>
                          </div>
                          <p className="dash-bus-message-matn d-block d-md-none">
                            درخواست شما برای ارتقا حساب کاربری دریافت شد.
                          </p>
                          <div className="d-flex dash-bus-message-timedate">
                            <span className="ms-4">8:23</span>
                            <span>20/7/1401</span>
                          </div> */}

                        <span className="">پیام جدیدی ندارید.</span>
                      </div>
                    </MDBCard>
                    {/* </Link> */}
                  </MDBCol>
                </MDBRow>
              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
        {/* left */}
      </div>
    </>
  );
};

export default BusinessDashboard;
